module.exports = __webpack_public_path__ + "static/img/um_mission.9e588881.png";